import { Button } from "primereact/button";
import { useInterval } from "primereact/hooks";
import { useEffect, useState } from "react";

export default function NextContentLoader({
    intervalToWait = 0,
    label = "Next",
    onClick,
    icon = "pi pi-arrow-right",
    iconPos = "right",
    severity = "success",
    outlined = true,
}) {
    const [secondsLeft, setSecondsLeft] = useState(intervalToWait);

    useEffect(() => {
        setSecondsLeft(intervalToWait);
    }, [intervalToWait]);

    useInterval(
        () => setSecondsLeft((prev) => Math.max(prev - 1, 0)),
        1000,
        secondsLeft > 0,
    );

    const ready = secondsLeft <= 0;
    const buttonLabel = ready ? label : `${secondsLeft}s`;

    return (
        <Button
            label={buttonLabel}
            icon={ready ? icon : undefined}
            iconPos={iconPos}
            severity={severity}
            outlined={outlined}
            disabled={!ready}
            onClick={onClick}
        />
    );
}
